//@flow
import React from "react"
import { Switch, Route } from "react-router-dom"
import UserListView from "./UserListView"
import UserFormView from "./UserFormView"
import queries from "./queries"

import type { Match } from "react-router-dom"
import type { UserListQuery } from "./types"

const Users = ({ match }: { match: Match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/new`} component={UserFormView} />
      <Route path={`${match.url}/:id`} component={UserFormView} />
      <Route component={UserListView} />
    </Switch>
  )
}

export { queries }

export type { UserListQuery }

export default Users



// WEBPACK FOOTER //
// ./src/Users/index.js